import { CancellableResult } from '../../../common/result';
import CompleteDocumentSelfieTask from '../background/CompleteDocumentSelfieTask';
import CompleteFaceAuthTask from '../background/CompleteFaceAuthTask';
import faceAuthenticationService from '../../../services/faceAuthentication';
import StepWorker, { StepWorkerResult } from './StepWorker';

export default class FaceAuthStep implements StepWorker {
  public requiresInit = false;

  // eslint-disable-next-line no-useless-constructor
  constructor(
    private userDid: string,
    private documentSelfieMode: boolean,
  ) {
    // eslint-disable-next-line no-empty-function
  }

  public async processStep(validationId: string): Promise<StepWorkerResult> {
    // use authentication with faceId for IDV, regular authentication otherwise
    const authenticationResult = this.documentSelfieMode
      ? await faceAuthenticationService.faceIdAuthenticate(this.userDid)
      : await faceAuthenticationService.authenticate(this.userDid, true);

    if (authenticationResult.isCancelled()) {
      return { result: CancellableResult.cancelled(authenticationResult.getDetail()) };
    }

    if (authenticationResult.isFailed()) {
      return { result: CancellableResult.failed(authenticationResult.failure(), authenticationResult.getDetail()) };
    }

    return {
      result: CancellableResult.noValueSuccess(authenticationResult.getDetail()),
      backgroundTask: this.documentSelfieMode
        ? new CompleteDocumentSelfieTask(validationId, authenticationResult.success())
        : new CompleteFaceAuthTask(validationId, authenticationResult.success()),
    };
  }
}
